import type { SidebarMenu } from './types';

type Key = 'index' | 'exchange' | 'return' | 'customerService' | 'order-cancel';

export const claimMap: Record<Key, SidebarMenu> = {
  index: {
    title: '취소・반품・교환 관리',
    path: '/claim',
    display: true,
  },
  exchange: {
    title: '교환 관리',
    path: '/claim/exchange',
    display: true,
  },
  return: {
    title: '반품 관리',
    path: '/claim/return',
    display: true,
  },
  customerService: {
    title: '문의관리',
    path: '/claim/customer-service',
    display: true,
  },
  'order-cancel': {
    title: '취소 관리',
    path: '/claim/order-cancel',
    display: true,
  },
};
